import { saveStateToLocalStorage } from '../../../utils/localStorage';
import { PanierActionTypes, RESET_PANIER } from '../types';

export function resetPanier(): PanierActionTypes {
	saveStateToLocalStorage('panier', { favorite: false, lignes: [] });
	return { type: RESET_PANIER };
}
